// Author Liang Gang Qiang
// Date 2022-05-13 17:10:15

import * as model from "@/model/sithMes/prd/SithMesPrdToolsInfoModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdToolsInfo(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'scrapVo'
    })
    .buildStore()
